import { ReactNode, useCallback, useState } from 'react'
import styled from 'styled-components'

import { StructureDto } from '@/endpoints/models'
import { ItemMenuDialog } from '@/types'

// Avoid a real box so triggers sit correctly in toolbars; menu items keep width on the child.
const MenuTriggerRow = styled.div`
	display: contents;
	width: 100%;
`

interface DialogWrapperProps {
	children: ReactNode | ((onClick: () => void) => ReactNode)
	className?: string
	dialog: ItemMenuDialog
	dispatch?: React.Dispatch<any>
	node?: StructureDto
	onRefresh?: () => void
	selectedNodes?: number[]
}

/**
 * Create openable dialog without having to add new state prop.
 */
export const DialogWrapper = ({
	children,
	className,
	dialog,
	dispatch,
	node,
	onRefresh,
	selectedNodes,
}: DialogWrapperProps) => {
	const [opened, setOpened] = useState(false)

	const onClose = useCallback(() => {
		setOpened(false)
	}, [])

	const onOpen = useCallback(() => {
		setOpened(true)
	}, [])

	return (
		<>
			{typeof children !== 'function' && (
				<div className={className} onClick={onOpen}>
					{children}
				</div>
			)}
			{typeof children === 'function' && (
				<MenuTriggerRow className={className}>
					{children(onOpen)}
				</MenuTriggerRow>
			)}
			{dialog(opened, onClose, node, dispatch, selectedNodes, onRefresh)}
		</>
	)
}
